import React from 'react'

import XLogo from '~img/logos/xcad-mono-gray.svg'

import * as s from './FooterBottom.module.scss'

const FooterBottom = () => {
  const currentYear = new Date().getFullYear()

  return (
    <div className={s.footerBottom}>
      <img src={XLogo} alt="xcad logo" width={75} />
      <p>All Rights Reserved © XCAD Network {currentYear}</p>
    </div>
  )
}

export default FooterBottom
